export default {
  savedSearches: [],
  savedPolicies: []
};
